import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LandingPage } from './pages/landing-page/landing-page';
import { Admin } from './pages/admin/admin';
import Login from './pages/login/loginPage'
import { RecordingsPage } from './pages/recordings-page/recordings-page';
import { useEffect } from 'react';

function App() {

  const isLoginUser = useSelector((state) => state.auth.isLoginUser);

  useEffect(()=>{
  },[isLoginUser])

  const isAuthenticated = () => {
    return localStorage.getItem('accessToken') !== null;
  };


  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/admin' element={(isAuthenticated()) ? <Navigate to='/dashboard' /> : <Login />} />
        <Route path='/dashboard' element={isAuthenticated() ? <Admin /> : <Navigate to='/admin' />} />
        <Route path='/recordings' element={<RecordingsPage />} />
      </Routes>
    </div>
  );
}

export default App;
